export default {"src":"/_next/static/media/faster.1fc5aebe.svg","height":95,"width":80};